import '@firebase/auth';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/auth/dist/index.esm.js
// module id = 20
// module chunks = 0